import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerSegmentation from '../features/segmentation/Segmentation';
import ClusterAnalysis from '../features/clustering/Clustering';
import MetadataExtraction from '../features/metadataExtraction/MetadataExtraction';
import AnalyzeData from '../features/analyzeData/AnalyzeData';
import QueryData from '../features/queryData/QueryData';
import KnowledgeGraph from '../features/knowledgeGraph/KnowledgeGraph';
import IngestData from '../features/ingestData/IngestData';
import DocIntelligence from '../features/docIntelligence/DocIntelligence';
import GovernanceIntake from '../features/governanceIntake/GovernanceIntake';
import DataTransfer from '../features/dataTransfer/DataTransfer';
import Investigate from '../features/investigate/Investigate';

const PATH_TITLE = {
  '/data-studio/segmentation':        'Clustering',
  '/data-studio/cluster-analysis':    'Cluster Analysis',
  '/data-studio/metadata':            'Metadata Extraction',
  '/data-studio/analyze':             'Analyze',
  '/data-studio/query':               'Query Data',
  '/data-studio/knowledge-graph':     'Knowledge Graph',
  '/data-studio/ingest':              'Ingest Data',
  '/data-studio/doc-intelligence':    'Doc Intelligence',
  '/data-studio/governance-intake':   'Governance Intake',
  '/data-studio/transfer':            'Data Transfer',
  '/data-studio/investigate':         'Investigate',
};

const TAB_TO_PATH = {
  segmentation:    '/data-studio/segmentation',
  metadata:        '/data-studio/metadata',
  analyzeData:     '/data-studio/analyze',
  queryData:       '/data-studio/query',
  knowledgeGraph:  '/data-studio/knowledge-graph',
  ingestData:      '/data-studio/ingest',
  docIntelligence: '/data-studio/doc-intelligence',
};

const DataStudioPage = () => {
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const [tabParams, setTabParams] = useState({});

  const handleTabSwitch = (id, params = {}) => {
    setTabParams(params);
    if (TAB_TO_PATH[id]) navigate(TAB_TO_PATH[id]);
  };

  const renderContent = () => {
    switch (pathname) {
      case '/data-studio/segmentation':     return <CustomerSegmentation />;
      case '/data-studio/cluster-analysis': return <ClusterAnalysis />;
      case '/data-studio/metadata':         return <MetadataExtraction />;
      case '/data-studio/analyze':          return <AnalyzeData onTabSwitch={handleTabSwitch} />;
      case '/data-studio/query':            return <QueryData sourceId={tabParams.sourceId} onTabSwitch={handleTabSwitch} />;
      case '/data-studio/knowledge-graph':  return <KnowledgeGraph />;
      case '/data-studio/ingest':           return <IngestData sourceId={state?.source} paths={state?.paths} />;
      case '/data-studio/doc-intelligence': return <DocIntelligence />;
      case '/data-studio/governance-intake': return <GovernanceIntake />;
      case '/data-studio/transfer':          return <DataTransfer />;
      case '/data-studio/investigate':       return <Investigate />;
      default:                              return null;
    }
  };

  return (
    <div className="h-full flex flex-col bg-gray-100">
      <div className="flex-none bg-gray-100 px-6 shadow-sm z-20">
        <div className="pt-4 pb-3 border-b border-gray-300">
          <h1 className="text-2xl font-bold text-primary">{PATH_TITLE[pathname] || 'Data Studio'}</h1>
        </div>
      </div>
      <div className={`flex-1 bg-gray-50 ${['/data-studio/governance-intake', '/data-studio/transfer', '/data-studio/investigate'].includes(pathname) ? 'overflow-hidden' : 'overflow-y-auto'}`}>
        {renderContent()}
      </div>
    </div>
  );
};

export default DataStudioPage;
